import React, { useState } from 'react';
import { Box, Typography, Button, TextField, Grid, Snackbar, Container, MenuItem } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useForm } from 'react-hook-form';

function Contact() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const onSubmit = (data) => {
    setIsSending(true);

    fetch("https://formsubmit.co/ajax/femtechsolutionsalem@gmail.com", {
      method: "POST",
      headers: { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      },
      body: JSON.stringify({
        ...data,
        _subject: `New Website Enquiry from ${data.name}`,
        _captcha: "false"
      })
    })
      .then(response => response.json())
      .then(responseData => {
        setOpenSnackbar(true);
        reset();
        setIsSending(false);
      })
      .catch(error => {
        console.error('FAILED...', error);
        alert("Failed to send message. Please try again later.");
        setIsSending(false);
      });
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  return (
    <Box sx={{ backgroundColor: '#f9f9f9', py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          className="section-title"
          sx={{
            textAlign: 'left',
            color: '#333',
            mb: 4,
            fontWeight: 'bold'
          }}
        >
          CONTACT US
        </Typography>

        <Grid container spacing={6}>
          {/* Left Side: Contact Details */}
          <Grid item xs={12} md={5}>
            <Box sx={{ backgroundColor: '#003366', color: 'white', p: 4, height: '100%', display: 'flex', flexDirection: 'column' }}>

              <Box sx={{ mb: 6 }}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', borderBottom: '1px solid rgba(255,255,255,0.2)', pb: 1 }}>
                  WE WELCOME PARTNERSHIPS WITH:
                </Typography>
                <ul style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
                  <li>Corporates</li>
                  <li>CSR Foundations</li>
                  <li>NGOs</li>
                  <li>Educational Institutions</li>
                  <li>Workplaces</li>
                </ul>
              </Box>

              <Box>
                <Typography variant="h6" sx={{ mb: 3, fontWeight: 'bold', borderBottom: '1px solid rgba(255,255,255,0.2)', pb: 1 }}>
                  GET IN TOUCH
                </Typography>

                <Box sx={{ display: 'flex', mb: 3, alignItems: 'flex-start' }}>
                  <LocationOnIcon sx={{ mr: 2, color: '#cc0000', mt: 0.5 }} />
                  <Typography>
                    Door No. 24/14, Ward 3,<br />
                    Sarakkapillaiyur Post,<br />
                    Kadayampatti Taluk,<br />
                    Salem – 636305,<br />
                    Tamil Nadu, India
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', mb: 3, alignItems: 'center' }}>
                  <PhoneIcon sx={{ mr: 2, color: '#cc0000' }} />
                  <Typography>+91 98426 74113</Typography>
                </Box>

                <Box sx={{ display: 'flex', mb: 3, alignItems: 'center' }}>
                  <MailOutlineIcon sx={{ mr: 2, color: '#cc0000' }} />
                  <Typography>femtechsolutionsalem@gmail.com</Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Right Side: Simple Form */}
          <Grid item xs={12} md={7}>
            <Box sx={{ backgroundColor: 'white', p: 4, border: '1px solid #ddd' }}>
              <Typography variant="h6" sx={{ mb: 3, color: '#555', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' }}>
                ENQUIRY FORM
              </Typography>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Name"
                      variant="outlined"
                      size="small"
                      {...register('name', { required: 'Name is required' })}
                      error={!!errors.name}
                      InputProps={{ style: { borderRadius: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Organization / Company"
                      variant="outlined"
                      size="small"
                      {...register('organization', { required: 'Organization is required' })}
                      error={!!errors.organization}
                      InputProps={{ style: { borderRadius: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Email"
                      variant="outlined"
                      size="small"
                      {...register('email', { required: 'Email is required' })}
                      error={!!errors.email}
                      InputProps={{ style: { borderRadius: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Purpose of Enquiry"
                      variant="outlined"
                      size="small"
                      defaultValue=""
                      inputProps={register('purpose', { required: 'Purpose is required' })}
                      error={!!errors.purpose}
                      InputProps={{ style: { borderRadius: 0 } }}
                    >
                      <MenuItem value="Product Enquiry">Product Enquiry</MenuItem>
                      <MenuItem value="CSR Partnership">CSR Partnership</MenuItem>
                      <MenuItem value="General Enquiry">General Enquiry</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Message"
                      multiline
                      rows={4}
                      variant="outlined"
                      {...register('message', { required: 'Message is required' })}
                      error={!!errors.message}
                      InputProps={{ style: { borderRadius: 0 } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      disabled={isSending}
                      variant="contained"
                      sx={{
                        backgroundColor: '#cc0000',
                        borderRadius: 0,
                        px: 4, py: 1.5,
                        '&:hover': { backgroundColor: '#aad400' }
                      }}
                    >
                      {isSending ? 'SENDING...' : 'SEND ENQUIRY'}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        message={
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CheckCircleIcon sx={{ color: '#aad400', mr: 1 }} />
            Message sent successfully!
          </Box>
        }
      />
    </Box>
  );
}

export default Contact;
